import React from "react";
import Layout from "Layout";
import {
  Grid,
  makeStyles,
  Typography,
  Box,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Collapse,
  TextField,
  Paper,
  Button,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@material-ui/core";
import {
  Edit,
  Delete,
  Block,
} from '@material-ui/icons/';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { withRouter } from "react-router";
import useApi from "Hooks/useApi";
import useAuth from "Hooks/useAuth";
import MuiAlert from "@material-ui/lab/Alert";

import "dayjs/locale/ja";
import dayjs from "dayjs";
dayjs.locale("ja");

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    // overflow: "auto",
    flexDirection: "column",
  },
  wrapper: {
    marginTop: theme.spacing(2),
  },
  table: {
    // width: "1600px",
    overflowX: "auto",
  },
  nthOfTypeOddRow: {
    backgroundColor: "#eee",
  },
  alert: {
    marginTop: theme.spacing(2),
  },
  dateCol: {
    width: "170px",
  },
  buttonCol: {
    textAlign: "center",
    width: "170px",
  },
  buttonRed: {
    color: "rgb(220, 0, 78)",
    "&:hover": {
      backgroundColor: "rgba(220, 0, 78, 0.04)",
    },
  },
  modalError: {
    color: "rgb(220, 0, 78)",
  },
}));

function LabelDictionaries(props) {
  const { request } = useApi();
  const auth = useAuth();
  const classes = useStyles();

  const [labelDictionaries, setLabelDictionaries] = React.useState([]);
  const [isShowModal, setIsShowModal] = React.useState(false);
  const [isShowModalError, setIsShowModalError] = React.useState(false);
  const [deleteId, setDeleteId] = React.useState(null);
  const [success, setSuccess] = React.useState(null);
  const [successMessage, setSuccessMessage] = React.useState(null);
  const [maxLabelDicts, setMaxLabelDicts] = React.useState(0);

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder - 分類辞書一覧";

    if (props.location.search.indexOf("create") > -1) {
      setSuccess("create");
      setSuccessMessage("登録が完了しました");
    }
    if (props.location.search.indexOf("edit") > -1) {
      setSuccess("edit");
      setSuccessMessage("更新が完了しました");
    }

    fetchLabelDictionaries();
    fetchAccountAttr();
  }, [auth.state.user.account_id]);

  const fetchLabelDictionaries = () => {
    if (!auth.state.user.account_id) {
      return;
    }

    request({
      method: "GET",
      url: `config/:account_id/analysis/labels`,
    }).then((result) => {
      setLabelDictionaries(result.data);
    });
  };

  const fetchAccountAttr = () => {
    if (!auth.state.user.account_id) {
      return;
    }
    // 登録できる分類辞書の最大数を取得する
    request({
      method: "POST",
      url: `config/:account_id/account`,
      data: {
        "attrs": [
          "max_label_dicts",
        ]
      },
    }).then((result) => {
      setMaxLabelDicts(result.data.max_label_dicts);
    });
  };

  const onClickEditButton = (id) => {
    props.history.push(`/config/dictionarysetting/classification/edit/${id}`);
  };

  const openDialog = (id, date) => {
    setDeleteId(id);
    setIsShowModal(true);
  };

  const deleteLabelDictionary = () => {
    request({
      method: "DELETE",
      url: `config/:account_id/analysis/labels/${deleteId}`,
    }).then(() => {
      fetchLabelDictionaries();
      setIsShowModal(false);
      setSuccess("delete");
    })
    .catch((error) => {
      fetchLabelDictionaries();
      setIsShowModal(false);
      setSuccess(null);
      if (error.response.status === 403) {
        setIsShowModalError(true);
      }
    });
  };

  // 新規登録ボタンのdisableチェック
  const createButtonDisable = () => {
    if (maxLabelDicts <= labelDictionaries.length) {
      return true;
    } else {
      return false;
    }
  }

  function Row(props) {
    const { row, index } = props;
    const isNthOfTypeOdd = index % 2 === 0 ? false : true ;
    const [open, setOpen] = React.useState(false);

    return (
      <React.Fragment>
        <TableRow className={isNthOfTypeOdd ? classes.nthOfTypeOddRow : null}>
          <TableCell>
            <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell>{row.name}</TableCell>
          <TableCell>{row.desc}</TableCell>
          <TableCell>{row.label}</TableCell>
          <TableCell className={classes.dateCol}>{row.updated_at ? dayjs(row.updated_at).format("YYYY/MM/DD HH:mm") : '-'}</TableCell>
          <TableCell className={classes.buttonCol}>
            <IconButton
              color="primary"
              aria-label="add an Edit"
              onClick={() => onClickEditButton(row.id)}
            >
              <Edit />
            </IconButton>
            <IconButton
              className={classes.buttonRed}
              aria-label="add an Delete"
              disabled={row.referenced.length}
              onClick={() => openDialog(row.id, row.deleted_at)}
            >
              <Delete />
            </IconButton>
          </TableCell>
        </TableRow>
        <TableRow className={isNthOfTypeOdd ? classes.nthOfTypeOddRow : null}>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box margin={1}>
                <TextField
                  label="キーワード"
                  inputProps={{ readonly: true }}
                  multiline
                  fullWidth
                  minRows={1}
                  maxRows={8}
                  value={row.words.join("\n")}
                  variant="outlined"
                />
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  return (
    <Layout
      content={
        <>
          <Grid>
            <Paper elevation={3} className={classes.paper}>
              <Typography variant="h6" color="primary">
                分類辞書一覧
              </Typography>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell>辞書名</TableCell>
                    <TableCell>概要</TableCell>
                    <TableCell>ラベル</TableCell>
                    <TableCell>更新日時</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {labelDictionaries.length > 0 ? labelDictionaries.map(
                    function (row, index) {
                      return <Row index={index+1} row={row} />
                    }
                  ) : (
                    <TableRow>
                      <TableCell colSpan={5} align="center">現在分類辞書はありません</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </Paper>
            {(success === "edit" || success === "create") && (
              <MuiAlert
                elevation={6}
                variant="filled"
                severity="success"
                className={classes.alert}
              >
                {successMessage}
              </MuiAlert>
            )}
            <Grid container justifyContent="center" className={classes.wrapper}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => props.history.push(`/config/dictionarysetting/classification/create`)}
                disabled={createButtonDisable()}
              >
                新規登録
              </Button>
            </Grid>
          </Grid>
          <Dialog open={isShowModal} onClose={() => setIsShowModal(false)}>
            <DialogContent>
              <DialogContentText>
                本当に削除してよろしいですか？
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button color="primary" onClick={() => deleteLabelDictionary()}>
                はい
              </Button>
              <Button color="primary" onClick={() => setIsShowModal(false)}>
                いいえ
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog open={isShowModalError} onClose={() => setIsShowModalError(false)}>
            <DialogContent>
              <DialogContentText
              className={classes.modalError}
              >
                <div style={{ textAlign: "center" }} ><Block style={{ marginTop: "15px", marginBottom: "15px" }} /></div>タスクに設定されている辞書は削除できません。
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button color="primary" onClick={() => setIsShowModalError(false)}>
                閉じる
              </Button>
            </DialogActions>
          </Dialog>
        </>
      }
    />
  );
}

export default withRouter(LabelDictionaries);
